import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Link} from "react-router-dom"
import './list.css'
import Slider from "react-slick";
import {userList} from '../../redux/chatuser.redux.js'
import { withRouter } from 'react-router-dom'
import {authenticationFn} from '../../redux/chatuser.redux.js'

import {getElementPosition} from '../../util.js'
import GiftAlert from '../../component/gift-alert/gift-alert.js'
import {getGiftSuccessCallBack} from  '../../redux/chatuser.redux.js'
import ToastBar from '../../component/toast/toast.js'
@withRouter
@connect(
  state=>state.chatuser,
  {userList,authenticationFn,getGiftSuccessCallBack}
)

class ReturnList extends React.Component{
	constructor(props){
		super(props)
		this.state={
			  GetPacks:'',
			  getCates:'',
			  zoneNum:0,
			  navNum:0,
			  showSelectWelfare:false,
		      visible:false,
		      showGetSuccess:false,
		      iTop:'',		     
		      giftData:'',
		      key:1,
		      inum:0,
		      packId:'',
		      showWrongAlert:false
		   
    	}
    	this.game_id = this.props.match.params.id	
    	this.handleLogin = this.handleLogin.bind(this)
    	this.showAlert = this.showAlert.bind(this)
    	this.showWrongAlert = this.showWrongAlert.bind(this)
    	this.ToastBarClose = this.ToastBarClose.bind(this)
    	this.onOff = true
    	this.myAccountData=''
	}
	componentDidMount(){
		
  		if(this.props.inum==='1'){
  			this.handleGetCates('1')
  		}
  		if(this.props.inum==='2'){
  			this.handleGetCates('4')
  		}

  	}
	componentWillReceiveProps(nextProps){
		
		if(this.props.getGiftSuccessData!==nextProps.getGiftSuccessData){
			if(nextProps.getGiftSuccessData==='1'){
				console.log(this.state.getCates[this.state.navNum])
		 		this.state.getCates[this.state.navNum]&&this.handleGetPacks(this.state.getCates[this.state.navNum].id)
		 		
		 	}
		}
	
  		 if (this.props.accountData.account!== nextProps.accountData.account||nextProps.ikey){
  		 	
  		 	this.myAccountData = nextProps.accountData
  		 	
			if(nextProps.accountData.grade&&this.props.inum==='1'){
				
				const oGrade = nextProps.accountData.grade
				
				var num =''
				if(oGrade>=8){
				num = 2
				}
				if(oGrade>4&&oGrade<=7){
				num = 1
				}
				if(oGrade<=4){
				num = 0
				}
				this.setState({
					navNum:num					
				})
				if(nextProps.ikey){
					this.handleGetCates('1')
					return
				}

		  		this.state.getCates[num]&&this.handleGetPacks(this.state.getCates[num].id,nextProps.accountData)
		  				  		
	  		}
	  		if(!nextProps.accountData.grade){
	  			this.state.getCates[0]&&this.handleGetPacks(this.state.getCates[0].id,nextProps.accountData)
	  			this.setState({
					navNum:0
				})
	  		}
	  		if(this.props.inum==='2'){
	  			
				
	  			if(parseFloat(nextProps.iMoney)||parseFloat(nextProps.iMoney)==0){
	  				/*
		  			if(parseFloat(nextProps.iMoney)<1000){
		  				this.setState({
							navNum:0					
						})			
				  		this.state.getCates[0]&&this.handleGetPacks(this.state.getCates[0].id)
		  			}else if(parseFloat(nextProps.iMoney)>1000&&parseFloat(nextProps.iMoney)<5000){
		  				
		  				this.setState({
							navNum:1					
						})	
						this.state.getCates[1]&&this.handleGetPacks(this.state.getCates[1].id)
		  			}else if(parseFloat(nextProps.iMoney)>5000){
		  				this.setState({
							navNum:2					
						})	
						
						this.state.getCates[2]&&this.handleGetPacks(this.state.getCates[2].id)
		  			}
		  			*/
	  			}else{
	  				this.state.getCates[0]&&this.handleGetPacks(this.state.getCates[0].id)
	  			}
	  		}
	  		
  	
  		 }

  	}
  	handleGetCates(num){
  		
  		axios.get('/fapi/recom/getCates?gameid='+this.game_id+'&type='+num)
    		.then(res=>{
    			if(res.data.return_code===0){
    				this.setState({
    					getCates:res.data.data
    				})
    				res.data.data.length&&this.handleGetPacks(res.data.data[this.state.navNum].id)
    			}
    			
    			
    		})

  	}
  	handleGetPacks(_id,accountData){
  		var acData = ''
  		if(this.myAccountData.t_account){  			
  				acData = this.myAccountData.t_account

  		}
  		axios.get('/fapi/recom/getPacks?gameid='+this.game_id+'&cateid='+_id+'&account='+acData)
  			.then(res=>{
  				
  				if(res.data.return_code===0){
  				

					this.setState({
						GetPacks:res.data.data
						
					})
					this.props.getGiftSuccessCallBack('0')
  				}
  				 				 				
  			})
  	} 
  	handleNav(i,_id){
		this.setState({
			navNum:i
		})
		this.handleGetPacks(_id)
  	}
  	
  
  	handleLogin(){		
		const pathname = this.props.location.pathname
		axios.get('/fapi/getLoginURL?redirect_url='+encodeURIComponent(encodeURIComponent(window.location.href)))
	      .then(res=>{
	       	if(res.data.return_code==0){
	       		window.location.href = res.data.redirect_url
	 
	       	}
					     
		 })		
			
	}
	showWrongAlert(e){
		this.setState({
	  		showWrongAlert:true
	  			
	  	})
	  	this.iTop = getElementPosition(e.target).y+'px'
	}
  	getGiftBtnFn(){
		
  		if(this.props.userlist.code===-1){
  			var str = '立即领取'
  			var icls = 'getBtn1'
  			var callBack = this.handleLogin
  			
  			if(this.props.inum==2&&this.state.navNum===0){
  				str = '1元领取'
  			}
  			if(this.props.authentication==1||this.props.authentication==''){
				
				return <button className="getBtn1" onClick={()=>this.handleLogin()}>{str}</button>
  			}
  			if(this.props.authentication==3){
				
				if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 1){
					
  					str = '立即领取'
  					
  					if(this.props.inum==2&&this.state.navNum===0){
  						
		  			 str = '1元领取'
		  			}
  				}
  				if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 0){  				
	  				 str = '待解锁'
	  				 icls = 'getBtn2'
	  				 callBack = function () { }
	  				 	
	  				
	  			}
	  			if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 2){  				
	  				 str = '已领取'
	  				  icls = 'getBtn2'
	  				  callBack = function () { }
	  			}
  				return <button className={icls} onClick={()=>callBack()}>{str}</button>
  			
				
  			}
  			if(this.props.authentication==2){
  				
  				return <button className="getBtn2" >待解锁</button>
  			}
  			
  		}else{
  			var str = ''
  			var icls = 'getBtn1'
  			var callBack = this.showAlert
  			if(this.props.authentication==3){
  				
  				if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 1){
					
  					str = '立即领取'
  					
  					if(this.props.inum==2&&this.state.navNum===0){
  						
		  			 str = '1元领取'
		  			}
		  			if(this.state.GetPacks[0].alert){
		  				callBack=this.showWrongAlert
		  			}
  				}
  				if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 0){  				
	  				 str = '待解锁'
	  				 icls = 'getBtn2'
	  				 callBack = function () { }
	  			}
	  			if(this.state.GetPacks&&this.state.GetPacks[0].can_receive === 2){  				
	  				 str = '已领取'
	  				  icls = 'getBtn2'
	  				 callBack = function () { }
	  			}
  				return <button className={icls} onClick={(e)=>callBack(e)}>{str}</button>
  			}
  			if(this.props.authentication==2){
  				
  				return <button className="getBtn2" >待解锁</button>
  			}
  			
  		}
  		
  	}
  	showAlert(e){
  		var idata = this.state.GetPacks[this.state.zoneNum].good_id
  		this.setState({
  			showSelectWelfare:true,
  			visible:false,
  			showGetSuccess:false,
  			iTop:getElementPosition(e.target).y+'px',
  			giftData:{id:idata},
  			key:this.state.key+1,
  			packId:this.state.GetPacks[this.state.zoneNum].id
  		})
  	}
  	afterChangeFn(i){
		this.setState({
			zoneNum:i
		})
  	}
  	handleStyle(e){
  		return {
			color:'red'
  		}
  	}
  	ToastBarClose(data){
  		
  		this.setState({
	  		showWrongAlert:false,
	  			
	  	})
  	}
  	render(){

  		const {navData} = this.props
		
	
  		return (

				<div className="return-list">
					<nav className={this.props.inum==='2'?'xiaohao-list':''}>
						{this.state.getCates&&this.state.getCates.map((item,i)=>{
							return (<div key={i} className={i===this.state.navNum?'active':''}>
										<span onClick={()=>this.handleNav(i,item.id)}>{item.name}</span>
										<i></i>										
									</div>)
						})}
												
					</nav>
					
			     	<div className="zone-list-name">
			     		<div className="zone-list">
							{
								this.state.GetPacks&&this.state.GetPacks.map((item,i)=>(
									<span className={this.state.zoneNum===i?"zone-active":""}  key={i}>{item.sub_cate_name}</span>
								))
							}
						</div>
					</div>
					<Slider 						
						
				        swipeToSlide={true}
         				focusOnSelect={false}
         				slidesToScroll={1}						
						infinite={false}
						arrows={false}
						afterChange={(i)=>this.afterChangeFn(i)}
						 className="return-gift-box2"
						
				     >
						{this.state.GetPacks&&this.state.GetPacks.map((item,i)=>(
							<div key={i}>
									
										<ul className="return-gift-list">
										{
											item.images.map((item,i)=>(
											
												<li  key={i}>
													<div className="return-list-box" style={{backgroundImage:'url('+item.imgurl+')'}}></div>
													<em>{item.title}</em>
												</li>
											
											))
										}
										</ul>
									
								</div>
								
							))}
						
					</Slider>
					{this.getGiftBtnFn()}
					<GiftAlert 
						key={this.state.key}
						showSelectWelfare={this.state.showSelectWelfare}
						visible={this.state.visible}
						showGetSuccess={this.state.showGetSuccess}
						iTop={this.state.iTop}
						giftData={this.state.giftData||''}
						packId={this.state.packId}
					></GiftAlert>
					{
						this.state.showWrongAlert&&<ToastBar 
							visible={this.state.showWrongAlert}
							title={'错误提示'}  
							isOkShow ={false} 
							iTop={this.iTop}
							itype={1}
							ToastBarClose={this.ToastBarClose}
							
						>
						<div className="return-wrong-alert">抱歉，您在7月1日前回归登录龙之谷，不能领取回归称号</div>
					</ToastBar>
					}
				</div>
  		)
  	}
}

export default ReturnList




// WEBPACK FOOTER //
// ./src/component/return-pre-list/list.js